module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-check-a361af71.svg";